<h3 mat-dialog-title>{{ 'common.alert-window.information' | translate }}</h3>
<mat-dialog-content class="mat-typography">
  <pre>
    {{ message }}
  </pre>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'common.accept' | translate }}</button>
</mat-dialog-actions>
